import React, { useState } from "react";
import { Button } from "reactstrap";
import { ChevronDown, ChevronUp } from "react-feather";
import { formatMoney } from "../../../utils/formatMoney";

/** One strip per currency: amounts in different currencies are never added together. */
export default function LedgerTotals({ totals, loading, failed = false }) {
  const [showAccounts, setShowAccounts] = useState(false);
  const byCurrency = totals?.by_currency || [];
  const byAccount = totals?.by_account || [];

  if (failed && !totals) {
    return <div className="gl-totals-empty">Totals are unavailable until the rows load.</div>;
  }
  if (loading && byCurrency.length === 0) {
    return <div className="gl-totals-empty">Calculating totals…</div>;
  }
  if (byCurrency.length === 0) {
    return <div className="gl-totals-empty">No movements match the current filters.</div>;
  }

  return (
    <div className="gl-totals">
      <div className="gl-totals-strip">
        {byCurrency.map((t) => (
          <div key={t.currency} className="gl-total-item">
            <div className="gl-total-head">
              <span className="gl-total-currency">{t.currency}</span>
              <span className="gl-total-count">{t.entries} movements</span>
            </div>
            <div className="gl-total-values">
              <div>
                <small>Debit</small>
                <strong className="text-danger">{formatMoney(t.debit, t.currency)}</strong>
              </div>
              <div>
                <small>Credit</small>
                <strong className="text-success">{formatMoney(t.credit, t.currency)}</strong>
              </div>
              <div>
                <small>Net</small>
                <strong className={Number(t.net) < 0 ? "text-danger" : "text-success"}>
                  {formatMoney(t.net, t.currency)}
                </strong>
              </div>
            </div>
          </div>
        ))}
        {byAccount.length > 0 && (
          <Button
            color="link"
            size="sm"
            className="gl-accounts-toggle d-inline-flex align-items-center gap-1"
            onClick={() => setShowAccounts((v) => !v)}
          >
            {showAccounts ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
            {byAccount.length} account balance{byAccount.length > 1 ? "s" : ""}
          </Button>
        )}
      </div>
      {showAccounts && byAccount.length > 0 && (
        <div className="gl-account-balances">
          {byAccount.map((a) => (
            <span key={a.bank_profile_id} className="gl-account-chip">
              <b>{a.label}</b> ****{a.account_last4}: {formatMoney(a.opening_balance, a.currency)} →{" "}
              <b>{formatMoney(a.closing_balance, a.currency)}</b>
            </span>
          ))}
          {totals?.accounts_truncated && (
            <span className="gl-muted small">Only the first 50 accounts are shown — narrow the filters to see others.</span>
          )}
        </div>
      )}
    </div>
  );
}
